import moment from 'moment';
import React from 'react';
import { Modal, ModalBody, ModalHeader, ModalFooter, Button } from 'reactstrap'

moment.locale('de');

export default class CustomCalendar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedTimeslot: null
    }

    this.prevWeek = this.prevWeek.bind(this);
    this.nextWeek = this.nextWeek.bind(this);
    this.handleTimeslotSelect = this.handleTimeslotSelect.bind(this);
  }

  prevWeek(e) {
    this.props.prevWeek(e);
  }

  nextWeek(e) {
    this.props.nextWeek(e);
  }

  handleTimeslotSelect(e) {
    this.setState({selectedTimeslot: e.target.dataset.fulltime});
    this.props.timeslotSelected({
      time: e.target.dataset.fulltime,
      token: e.target.dataset.token
    });
  }

  mergeDatesAndTimes(dates, times) {

    let groupedTimes = {};
    // grop date by date
    times.forEach((el) => {
      const date = el.time.slice(0, 10);
      if (!groupedTimes.hasOwnProperty(date)) {
        groupedTimes[date] = [];
      }
      groupedTimes[date].push(el);
    });

    return dates.map((el) => {
      if (groupedTimes.hasOwnProperty(el.date)) {
        el.times = groupedTimes[el.date];
      }
      return el;
    });
  }

  render() {
    const calendarLoaded = this.props.calendarLoaded;
    const fromDate = moment(this.props.currentWeek.from).format("DD. MMMM YYYY");
    const toDate = moment(this.props.currentWeek.to).format("DD. MMMM YYYY");

    return (
        <Modal isOpen={this.props.isOpen} toggle={this.props.toggle} className="custom-calendar-dialog">
          <ModalHeader toggle={this.props.toggle} />
          <ModalBody>
          <div className="header">
            <div className="header-title">Termine im Zeitraum vom: {fromDate} - {toDate}</div>
            <div className="header-buttons">
              <div className="arrow-button" onClick={this.prevWeek}>
                <img src="/img/arrow-left.png" />
              </div>
              <div className="arrow-button" onClick={this.nextWeek}>
                <img src="/img/arrow-right.png" />
              </div>
            </div>
          </div>

          { calendarLoaded ? this.renderCalendar() : this.renderLoadingScreen() }

          </ModalBody>
        </Modal>
    )
  }

  renderLoadingScreen() {
    return (
      <div className="loading-container">
        <img src="/img/loading.gif" />
      </div>
    )
  }

  renderTimeslots(times) {
    return (
      <div>
        {times.map((timeslot, index) => {
            return (
              <div
                key={index}
                className={"timeslot" + (timeslot.time == this.state.selectedTimeslot ? " selected" : "") }
                data-fulltime={timeslot.time}
                data-token={timeslot.token}
                onClick={this.handleTimeslotSelect}
              >
                {moment(timeslot.time).format('HH:mm')}
              </div>
            )
        })}
      </div>
    )
  }

  renderCalendar() {
    const data = this.mergeDatesAndTimes(this.props.availableDates, this.props.availableTimes);

    return (
      <div className="custom-calendar">
        <div className="cal-row">
          {data.map((val, index) => {
            return (
              <div className={"day-container" + (val.available ? "" : " disabled")}>
                <div className="date">
                  <div className="full-date">{moment(val.date).format('DD.MM.YYYY')}</div>
                  <div className="day-name">{moment(val.date).format('dddd')}</div>
                </div>
                <div className="times">
                  { val.hasOwnProperty("times") ? this.renderTimeslots(val.times) : '' }
                </div>
              </div>
            )
          })}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/CustomCalendar.js